export const sessionIdKey = "sessionId";
export const userIdKey = "userId";
